<div class="form-group" [formGroup]="dataForm">
    <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text"><i class="fas fa-search-location"></i></span>
        </div>
        <label for="findAnAddress" class="visually-hidden">Find An Address</label>
        <input id="findAnAddress" type="text" class="form-control" formControlName="address" (focus)="dataForm.reset()" [id]="id" placeholder="Find an address" [tabindex]="0">
    </div>
</div>